@if (cartProduct) {
  <div
    class="cart-product-detail flex-column justify-between align-stretch"
    >
    <!-- Header-->
    @if (cartProduct.product.image?.fullUrl) {
      <div class="cart-product-detail-image-container">
        <app-header [imageUrl]="cartProduct.product.image?.fullUrl"> </app-header>
      </div>
    }
    <!-- Content-->
    <app-bottom-container class="flex-100">
      <div class="cart-product-detail-content flex-column">
        <!-- Title & qualités-->
        <div
          class="cart-product-detail-content-header flex-column gap-2"
          >
          <!-- product title-->
          <div
            class="cart-product-detail-title flex-row justify-center align-stretch gap-20"
            >
            <div>{{ cartProduct.product.name }}</div>
          </div>
        </div>
        <div
          class="cart-product-quantity-actions flex-row justify-center align-center"
          >
          <button
            mat-flat-button
            class="cart-product-quantity-button"
            (click)="onProductRemoved()"
            >
            <mat-icon>remove</mat-icon>
          </button>
          <span class="cart-product-quantity">
            {{ cartProduct.quantity }}
          </span>
          @if (canOrderProduct) {
            <button
              mat-flat-button
              class="cart-product-quantity-button"
              (click)="onProductAdded()"
              >
              <mat-icon>add</mat-icon>
            </button>
          }
          <!-- Indisponibilité-->
          @if (!isAvailable) {
            <div class="cart-product-unavailable">{{ "MENU.PRODUCT.UNAVAILABLE" | transloco }}</div>
          }
          @if (isAvailable && !canOrderProduct) {
            <div class="cart-product-unavailable">{{ "MENU.PRODUCT.MAXREACHED" | transloco }}</div>
          }
        </div>
        <!-- Buttons-->
        <div
          class="cart-product-detail-buttons flex-row justify-center align-center gap-10"
          >
          <button
            class="full-width"
            mat-flat-button
            color="accent"
            (click)="onDeleteQuantityProduct()"
            >
            {{ "CART.PRODUCT_DELETE" | transloco }}
          </button>
          <button
            class="full-width"
            mat-flat-button
            color="accent"
            (click)="onExit()"
            >
            {{ "COMMON.CLOSE" | transloco }}
          </button>
        </div>
      </div>
    </app-bottom-container>
  </div>
}
